<template>
  <div class="page">
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <h4 class="m-0">
        Global Permissions
      </h4>
    </div>

    <div
      v-if="users.loading"
      class="d-flex justify-content-center align-items-center py-5"
    >
      <b-spinner />
    </div>
    <template v-else>
      <div
        v-if="currentUserPermission !== permissionTypes.admin"
        class="d-flex flex-column align-items-center justify-content-center py-5"
      >
        <h1>403 - Forbidden</h1>
        <p>You don't have permission to view this page</p>
      </div>

      <div
        v-else
        id="pageContent"
        class="page-content p-4"
      >
        <div class="row">
          <div class="col">
            <div class="mb-2">
              <input
                id="searchUsersInput"
                ref="usersSearchInput"
                v-model="keyword"
                v-debounce="searchForUsersAndGroups"
                class="form-control"
                placeholder="Type to search for users and Groups"
              >
            </div>
            <b-alert
              show
              variant="info"
            >
              The list below displays the first 100 users and groups in alphabetical order.
              If you're looking for a specific user or group, please enter your search criteria to find them.
            </b-alert>
            <div
              v-if="users.loading"
              class="d-flex justify-content-center align-items-center py-5"
            >
              <b-spinner />
            </div>
            <template v-else>
              <b-list-group-item
                v-for="user in users.data"
                button
                class="d-flex align-items-center search-users-option"
              >
                <b-avatar
                  variant="primary"
                  :text="getAvatarText(user)"
                  class="mr-3"
                />
                <span class="mr-auto">{{ user.displayName }}</span>
                <b-form-select
                  v-model="user.permission.role"
                  class="user-select-permission"
                  style="width: 6rem"
                  :options="roles"
                  @change="onUserRoleChange(user)"
                />
              </b-list-group-item>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import UsersView from './UsersView';
import ModulesView from './ModulesView';
import {createNamespacedHelpers} from 'vuex';
import {axiosClient} from '../../../core/services/http.service';

const {
  mapActions: mapActionsUser,
  mapState: mapStateUser,
  mapMutations: mapMutationsUser,
} = createNamespacedHelpers('user');
const {mapState: mapStateDm} = createNamespacedHelpers('dataManagement');

export default {
  name: 'GlobalPermissions',
  components: {
    UsersView,
    ModulesView,
  },
  data: () => ({
    keyword: null,
    keywordGroup: null,
    roles: [
      {value: null, text: 'None'},
      {value: 'user', text: 'User'},
      {value: 'admin', text: 'Admin'},
    ],
  }),
  computed: {
    ...mapStateUser({
      users: state => state.users,
      groups: state => state.groups,
      currentUserPermission: state => state.currentUserAdpPermission.data?.role,
    }),
    ...mapStateDm(['permissionTypes']),
    // filteredUsers() {
    //   return this.keyword ? this.users.data.filter(user => user.displayName.toLowerCase().includes(this.keyword.toLowerCase())) : this.users.data
    // },
    // filteredGroups() {
    //   return this.keywordGroup ? this.groups.data.filter(group => group.DisplayName.toLowerCase().includes(this.keywordGroup.toLowerCase())) : this.groups.data
    // },
  },
  methods: {
    ...mapActionsUser(['getUsersAndGroupsWithPermissions']),
    ...mapMutationsUser(['updateSingleUser', 'updateSingleGroup']),
    getAvatarText(user) {
      return user.displayName.split(' ').map(el => el[0] ? el[0].toUpperCase() : '').join('');
    },
    // getAvatarTextForGroup(group) {
    //   return group.DisplayName[0].toUpperCase()
    // },
    async onUserRoleChange(userOrGroup) {
      if (userOrGroup.permission.role) {
        if (userOrGroup.permission.adPpermissionGuid) {
          const {success, body} = await axiosClient.put('/api/ADPPermission', userOrGroup.permission);
          if (success) {
            this.updateSingleUser({...userOrGroup, permission: body});
            // if (userOrGroup.type === 'user') {
            //   this.updateSingleUser({...userOrGroup, permission: body})
            // } else {
            //   this.updateSingleGroup({...userOrGroup, permission: body})
            // }
            this.$toasted.success(`User "${userOrGroup.displayName}'s" role was successfully changed`, {
              duration: TOASTER_DURATION,
            });
          } else {
            this.$toasted.error(`User "${userOrGroup.displayName}'s" role was NOT successfully changed`, {
              duration: TOASTER_DURATION,
            });
          }
        } else {
          const {success, body} = await axiosClient.post('/api/ADPPermission', userOrGroup.permission);
          if (success) {
            this.updateSingleUser({...userOrGroup, permission: body});
            // if (userOrGroup.type === 'user') {
            //   this.updateSingleUser({...userOrGroup, permission: body})
            // } else {
            //   this.updateSingleGroup({...userOrGroup, permission: body})
            // }

            this.$toasted.success(`User "${userOrGroup.displayName}'s" role was successfully changed`, {
              duration: TOASTER_DURATION,
            });
          } else {
            this.$toasted.error(`User "${userOrGroup.displayName}'s" role was NOT successfully changed`, {
              duration: TOASTER_DURATION,
            });
          }
        }
      } else {
        const {
          success,
          body,
        } = await axiosClient.delete(`/api/ADPPermission/${userOrGroup.permission.adPpermissionGuid}`);
        if (success) {
          this.updateSingleUser({...userOrGroup, permission: {role: null, userGuid: userOrGroup.permission.userGuid}});
          // if (userOrGroup.type === 'user') {
          //   this.updateSingleUser({...userOrGroup, permission: {role: null, userGuid: userOrGroup.permission.userGuid}})
          // } else {
          //   this.updateSingleGroup({...userOrGroup, permission: {role: null, userGuid: userOrGroup.permission.userGuid}})
          // }
          this.$toasted.success(`User "${userOrGroup.displayName}'s" role was successfully changed`, {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(`User "${userOrGroup.displayName}'s" role was NOT successfully changed`, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    async searchForUsersAndGroups() {
      await this.getUsersAndGroupsWithPermissions(this.keyword);
    },
  },
  mounted() {
    this.getUsersAndGroupsWithPermissions();
  },
};
</script>

<style lang="scss">
.nav-content {
  background: white;
}
</style>
